/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function(event) {
    const mediaqueryMobile = window.matchMedia("(min-width: 768px)");
    AOS.init()
    MicroModal.init()

    const collectionList = document.querySelectorAll("#collections li");
    collectionList.forEach((element) => {


        $(element).find('a').click(function (e) {
            e.preventDefault();
            var $this = $(this);
            const $link = this
            if ($this.hasClass('clicked')){
                $this.removeClass('clicked'); 
                window.location = this.href
            }else{
                $this.addClass('clicked');
                setTimeout(function() { 
                    if ($this.hasClass('clicked')){
                        $this.removeClass('clicked'); 
                        if ($(window).width() < 768) {
                            const collectionImage = document.querySelector("#collection-image")
                            const collectionBackground = document.querySelector("#choose-goal")
                            collectionImage.style.backgroundImage = `url(${element.dataset.image})`
                            collectionBackground.style.background = `${element.dataset.background}`
                        }
                        else{
                            window.location = $link.href;
                        }              
                    }
                }, 500);          
            }
        });

        element.addEventListener("mouseover", (event) => {
            const collectionImage = document.querySelector("#collection-image")
            const collectionBackground = document.querySelector("#choose-goal")
            collectionImage.style.backgroundImage = `url(${element.dataset.image})`
            collectionBackground.style.background = `${element.dataset.background}`
        })
    })

    const productTab = document.querySelectorAll(".tabs-product .tab-item")
    if(productTab.length) {
        productTab.forEach((element) => {
            element.addEventListener("mouseover", (event) => {
                document.querySelector("a.active").classList.remove("active")
                element.querySelector("a").classList.add("active")
                const description = element.querySelector(".description").innerHTML
                const tabDescription = document.querySelector("#tab-description p")
                tabDescription.innerHTML = description
                tabDescription.animate([
                    { transform: 'scaleY(0)' },
                    { transform: 'scaleY(1)' }
                  ], {
                    duration: 500,
                });
            })
        })
    }

    if (!mediaqueryMobile.matches){
        if( document.querySelectorAll('.key-ingredients > .slider-ingredients > div').length > 1 ) {
            $(".key-ingredients > .slider-ingredients").addClass("main-carousel")
        }

        if( document.querySelectorAll('.certifications > .slider-ingredients > div').length > 1 ) {
            $(".certifications > .slider-ingredients").addClass("main-carousel")
        }
    }
    const elem = document.querySelectorAll('.main-carousel[data-mobile-slider="true"]');
    elem.forEach((carousel) => {
        const flkty = new Flickity( carousel, {
            autoPlay: false,
            wrapAround: true,
            adaptiveHeight: true,
            pageDots: false,
            prevNextButtons: false,
            groupCells: 1,
            cellAlign: 'left'
        }); 
    });

    const carousel_pdp = document.querySelectorAll('.carousel-pdp');
    carousel_pdp.forEach((carousel) => {
        const flkty = new Flickity( carousel, {
            autoPlay: false,
            wrapAround: true,
            adaptiveHeight: true,
            pageDots: true,
            prevNextButtons: mediaqueryMobile.matches,
            groupCells: 1
        }); 
    });

    const carousel_banner = document.querySelectorAll('.carousel-banner');
    carousel_banner.forEach((carousel) => {
        console.log("Active ",carousel.dataset.activeSlider)
        if (!carousel.dataset.activeSlider) return;
        const flkty = new Flickity( carousel, {
            autoPlay: true,
            wrapAround: true,
            adaptiveHeight: true,
            pageDots: mediaqueryMobile.matches,
            prevNextButtons: false
        });
        const images = carousel.querySelectorAll('img');
        const title = document.querySelector('.carousel-title');
        const content = document.querySelector('.carousel-content');
        const button = document.querySelector('.carousel-button');
        flkty.on( 'change', function( index ) {
            title.innerText = images[index].dataset.title
            title.style.color = `${images[index].dataset.colortext}`
            content.innerText = images[index].dataset.content
            content.style.color = `${images[index].dataset.colortext}`
            button.innerText = images[index].dataset.button
            button.href = images[index].dataset.link
            button.style.color = images[index].dataset.colortextbutton
            button.style.backgroundColor = images[index].dataset.backgroundbutton
        });
    });

    function handleChangeSelect(event) {
        const $content = event.target.parentNode
        const selectVariant = $content.querySelectorAll("select.select-variant")
        let cadena = ''
        selectVariant.forEach(element => {
          cadena += element.value
        });
        const selectVariantId = $content.querySelectorAll("#SingleOptionSelector option");
        const $inputId = $content.querySelector("#id")
        let id = $inputId.value
        selectVariantId.forEach((option) => {
          if(cadena == option.text.replaceAll(" / ", '')) {
            id = option.value;
          }
        })
        $inputId.value = id
    }

    // Informed-sports icon addition
    function loadInformedSportIcons(scope = null) {
        let isIcon  = `<div id="informed_sport_icon">`;
            isIcon += `<svg fill="none" height="125" viewbox="0 0 125 125" width="125" xmlns="http://www.w3.org/2000/svg" class="icon">`;
            isIcon += `<g clip-path="url(#clip-informed-sport)">`;
            isIcon += `<path d="M34.6977 101.021C36.0154 102.778 36.4546 104.535 35.137 105.853L33.3801 108.049C32.9408 108.927 32.0624 109.367 31.1839 109.367C30.7447 109.806 30.7447 109.806 30.7447 109.806C29.8663 109.806 29.4271 109.367 28.5486 108.927L24.5956 105.853C23.7172 105.414 23.2779 104.535 23.2779 103.657C23.2779 102.778 23.2779 101.9 24.1564 101.021L25.4741 99.2644L28.1094 101.461L27.2309 102.778C26.7917 103.217 26.7917 103.217 27.2309 103.657L29.8663 105.853H30.3055C30.3055 105.853 30.7447 105.853 30.7447 105.414L31.6232 104.096C32.0624 103.657 31.6232 103.657 31.6232 103.217L28.9878 99.7036C27.6702 97.9468 27.2309 96.1899 28.5486 94.8722L30.3055 92.6761C30.7447 92.2369 31.6232 91.7976 32.5016 91.7976C33.3801 91.7976 34.2585 91.7976 35.137 92.6761L39.09 95.7506C40.4076 96.6291 40.4076 98.8252 39.5292 100.143L38.2115 101.9L35.137 99.7036L36.0154 98.386C36.4546 97.9468 36.4546 97.9468 36.0154 97.5075L33.3801 95.3114C32.9408 94.8722 32.9408 94.8722 32.5016 95.3114L31.6232 96.6291C31.1839 97.0683 31.6232 97.0683 31.6232 97.5075L34.6977 101.021Z" fill="black"></path> <path d="M53.5856 103.217C54.0248 104.096 54.0248 104.974 53.5856 105.853L52.2679 109.806C51.8287 110.684 51.3895 111.563 50.511 112.002C49.6326 112.441 48.7541 112.441 47.8757 112.002L43.0442 110.245L41.2874 115.516L37.7736 114.198L43.4835 98.386L51.3895 101.021C52.7071 101.9 53.1464 102.339 53.5856 103.217Z" fill="black"></path> <path d="M68.5196 106.292V116.394C68.5196 117.273 68.0804 118.151 67.6411 119.029C67.2019 119.469 66.3235 119.908 65.0058 119.908H59.2959C57.0998 119.908 55.7821 118.59 55.7821 116.394V106.292C55.7821 105.414 56.2214 104.535 56.6606 103.657C57.0998 103.217 57.9782 102.778 59.2959 102.778H65.0058C66.7627 102.778 68.5196 104.096 68.5196 106.292Z" fill="black"></path> <path d="M83.0131 108.927L87.8445 114.198L84.3307 115.516L79.9385 110.684L77.7424 111.563L79.9385 117.273L76.4247 118.59L70.2756 102.339L78.1816 99.2644C79.0601 98.8252 79.9385 98.8252 80.817 99.2644C81.6954 99.7036 82.1346 100.143 82.5738 101.461L83.8915 104.974C84.77 106.731 84.3307 108.049 83.0131 108.927Z" fill="black"></path> <path d="M90.9182 95.7504L98.8242 106.292L96.1889 108.488L87.8437 97.9465L84.3299 100.582L82.573 97.9465L92.2359 90.4798L93.9928 93.1151L90.9182 95.7504Z" fill="black"></path> <path d="M124.3 62.3696H98.8251C98.8251 82.5739 82.1346 99.2643 61.9304 99.2643C61.4912 99.2643 61.0519 99.2643 60.6127 99.2643C60.1735 99.2643 60.1735 99.2643 59.7343 99.2643H59.2951H58.8558H58.4166C57.9774 99.2643 57.9774 99.2643 57.5382 99.2643C57.0989 99.2643 56.6597 99.2643 56.6597 99.2643C56.2205 99.2643 55.7813 99.2643 55.3421 98.8251H54.9028H54.4636H54.0244H53.5852C53.1459 98.8251 53.1459 98.8251 52.7067 98.3859C51.8283 98.3859 51.389 97.9466 50.5106 97.5074C50.0714 97.5074 50.0714 97.5074 49.6322 97.0682C48.7537 96.629 48.3145 96.629 48.3145 96.1898C47.8753 96.1898 47.8753 95.7505 47.436 95.7505C46.5576 95.3113 46.1184 94.8721 45.2399 94.8721C44.8007 94.8721 44.8007 94.4329 44.3615 94.4329C44.3615 94.4329 43.9223 94.4329 43.9223 93.9936C43.483 93.9936 43.483 93.5544 43.0438 93.5544C42.6046 93.1152 42.1654 93.1152 41.7262 92.676C41.2869 92.676 41.2869 92.2367 40.8477 92.2367C40.4085 92.2367 40.4085 91.7975 39.9693 91.7975C39.53 91.3583 39.53 91.3583 39.0908 90.9191C37.7731 90.0406 36.8947 89.1622 36.0163 87.8445C35.1378 86.9661 34.6986 86.0876 33.8201 85.6484C33.3809 85.2092 33.3809 85.2092 32.9417 84.77C32.9417 84.3307 32.5025 84.3307 32.5025 83.8915L32.0633 83.4523C31.624 83.0131 31.624 82.5739 31.1848 82.1346L30.7456 81.6954C30.7456 81.6954 30.7456 81.2562 30.3064 81.2562C30.3064 80.817 29.8671 80.817 29.8671 80.3777C29.4279 79.9385 29.4279 79.4993 29.4279 79.0601C29.4279 79.0601 29.4279 78.6208 28.9887 78.6208C28.9887 78.6208 28.9887 78.1816 28.5495 78.1816C28.1102 77.7424 28.1102 76.864 27.671 76.4247C27.671 76.4247 27.671 75.9855 27.2318 75.9855C26.7926 75.1071 26.3534 73.7894 26.3534 72.911C26.3534 72.4717 26.3534 72.4717 26.3534 72.0325C26.3534 70.2756 25.9141 69.3972 25.9141 68.0795V67.6403C25.9141 67.2011 25.9141 66.7618 25.9141 66.7618V66.3226C25.9141 65.8834 25.9141 65.4442 25.9141 64.5657V64.1265C25.9141 63.6873 25.9141 63.6873 25.9141 63.2481C25.9141 62.8088 25.9141 62.8088 25.9141 62.3696H0C0 27.671 27.671 0 62.3696 0C96.629 0 124.3 27.671 124.3 62.3696Z" fill="white"></path> <path d="M25.0357 56.2205C25.0357 55.3421 25.4749 52.2675 26.7926 49.1929C29.4279 41.2869 34.2594 36.4555 36.0163 35.1378C37.3339 33.8201 41.7262 29.8671 48.3145 27.2318C51.389 25.9141 54.4636 25.0357 55.7813 25.0357C57.9774 24.5965 60.1735 24.1572 62.3696 23.718C67.2011 23.2788 70.7148 25.0357 75.1071 26.7926C78.1816 28.1102 82.1346 29.8671 86.5269 33.3809C89.1622 35.577 92.2368 38.2124 94.8721 43.0438C96.629 46.5576 97.5074 49.6322 97.9466 50.5106C98.3859 51.8283 98.8251 54.0244 99.2643 57.9774C99.7035 59.7343 99.7035 61.0519 100.143 62.3696C104.096 62.3696 108.049 62.3696 112.002 62.3696C115.955 62.3696 120.347 62.3696 124.3 62.3696C124.3 62.3696 124.3 62.3696 124.3 61.9304C124.3 27.671 96.629 0 62.3696 0C28.1102 0 0 27.671 0 62.3696H0.439223C6.14912 62.3696 10.5413 62.3696 12.2982 62.3696C14.9336 62.3696 19.3258 62.3696 24.5965 62.3696C24.5965 60.6127 24.5965 58.4166 25.0357 56.2205Z" fill="black"></path> <path d="M62.3696 2.19611C28.9887 2.19611 2.19611 28.9887 2.19611 62.3696H25.4749C25.4749 52.2675 29.4279 43.0438 36.4555 36.4555C37.7731 35.1378 47.8753 25.4749 62.3696 25.4749C79.4993 25.4749 93.1152 38.2124 97.5074 51.389C98.8251 55.7813 99.2643 59.7343 99.2643 62.3696H122.543C122.543 28.9887 95.3113 2.19611 62.3696 2.19611ZM93.9936 93.1152L92.2367 90.4799L82.5739 97.9466L84.77 100.582L88.2838 97.9466L96.629 108.488L99.2643 106.292L90.9191 95.7505L93.9936 93.1152ZM84.3307 105.413L83.0131 101.9C82.5739 101.021 82.1346 100.143 81.2562 99.7035C80.3777 99.2643 79.4993 99.2643 78.6208 99.7035L70.2756 102.339L75.9855 118.151L79.4993 116.833L77.3032 111.123L79.4993 110.245L83.8915 115.076L87.8445 114.198L83.0131 109.366C84.3307 108.049 84.77 106.731 84.3307 105.413ZM65.0049 102.778H59.2951C58.4166 102.778 57.5382 103.217 56.6597 103.657C56.2205 104.096 55.7813 104.974 55.7813 106.292V116.394C55.7813 118.59 57.0989 119.908 59.2951 119.908H65.0049C65.8834 119.908 66.7618 119.469 67.6403 119.029C68.0795 118.59 68.5187 117.712 68.5187 116.394V106.292C68.5187 104.096 66.7618 102.778 65.0049 102.778ZM51.389 101.46L43.483 98.8251L37.7731 114.637L41.2869 115.955L43.0438 110.684L47.8753 112.441C48.7537 112.88 49.6322 112.88 50.5106 112.441C51.389 112.002 51.8283 111.563 52.2675 110.245L53.5852 106.292C54.0244 105.413 54.0244 104.535 53.5852 103.657C53.1459 102.339 52.7067 101.9 51.389 101.46ZM31.624 97.9466C31.1848 97.5074 31.1848 97.5074 31.624 97.0682L32.5025 95.7505C32.9417 95.3113 32.9417 95.3113 33.3809 95.7505L36.0163 97.9466C36.4555 98.3859 36.4555 98.3859 36.0163 98.8251L35.1378 99.7035L37.7731 101.9L39.53 100.143C40.8477 98.3859 40.4085 96.629 39.0908 95.3113L35.1378 92.2367C34.2594 91.7975 33.3809 91.3583 32.5025 91.3583C31.624 91.3583 30.7456 91.7975 30.3064 92.676L28.5495 94.8721C27.671 96.1898 27.671 97.9466 28.9887 99.7035L31.624 103.217C32.0633 103.657 32.0633 103.657 31.624 104.096L30.7456 105.413L30.3064 105.853H29.8671L27.2318 103.657C26.7926 103.217 26.7926 103.217 27.2318 102.778L28.1102 101.46L25.4749 99.2643L23.718 101.021C23.2788 101.9 22.8396 102.778 22.8396 103.657C22.8396 104.535 23.2788 105.413 24.1572 105.853L28.1102 108.927C28.9887 109.366 29.8671 109.806 30.7456 109.806H31.1848C32.0633 109.806 32.9417 109.366 33.3809 108.488L35.1378 105.853C36.0163 104.535 36.0163 102.778 34.6986 101.021L31.624 97.9466Z" fill="white"></path> <path d="M99.2643 62.3695C99.2643 82.5737 82.5739 99.2642 62.3696 99.2642C61.9304 99.2642 61.4912 99.2642 61.0519 99.2642C60.6127 99.2642 60.6127 99.2642 60.1735 99.2642H59.7343H59.2951H58.8558C58.4166 99.2642 58.4166 99.2642 57.9774 99.2642C57.5382 99.2642 57.0989 99.2642 57.0989 99.2642C56.6597 99.2642 56.2205 99.2642 55.7813 98.825H55.3421H54.9028H54.4636H54.0244C53.5852 98.825 53.5852 98.825 53.1459 98.3858C52.2675 98.3858 51.8283 97.9465 50.9498 97.5073C50.5106 97.5073 50.5106 97.5073 50.0714 97.0681C48.7537 96.6289 48.3145 96.6289 48.3145 96.1896C47.8753 96.1896 47.8753 95.7504 47.436 95.7504C46.5576 95.3112 46.1184 94.872 45.2399 94.872C44.8007 94.872 44.8007 94.4328 44.3615 94.4328C44.3615 94.4328 43.9223 94.4328 43.9223 93.9935C43.483 93.9935 43.483 93.5543 43.0438 93.5543C42.6046 93.1151 42.1654 93.1151 41.7262 92.6759C41.2869 92.6759 41.2869 92.2366 40.8477 92.2366C40.4085 92.2366 40.4085 91.7974 39.9693 91.7974C39.53 91.3582 39.53 91.3582 39.0908 90.919C37.7731 90.0405 36.8947 89.1621 36.0163 87.8444C35.1378 86.966 34.6986 86.0875 33.8201 85.6483C33.3809 85.2091 33.3809 85.2091 32.9417 84.7699C32.5025 84.3306 32.5025 84.3306 32.5025 83.8914L32.0633 83.4522C31.624 83.013 31.624 82.5737 31.1848 82.1345L30.7456 81.6953C30.7456 81.6953 30.7456 81.2561 30.3064 81.2561C30.3064 80.8169 29.8671 80.8169 29.8671 80.3776C29.4279 79.9384 29.4279 79.4992 29.4279 79.06C29.4279 79.06 29.4279 78.6207 28.9887 78.6207C28.9887 78.6207 28.9887 78.1815 28.5495 78.1815C28.1102 77.7423 28.1102 76.8638 27.671 76.4246C27.671 76.4246 27.671 75.9854 27.2318 75.9854C26.7926 75.107 26.3534 73.7893 26.3534 72.9108C26.3534 72.4716 26.3534 72.4716 26.3534 72.0324C26.3534 70.2755 25.9141 69.3971 25.9141 68.0794V67.6402C25.9141 67.201 25.9141 66.7617 25.9141 66.7617V66.3225C25.9141 65.8833 25.9141 65.4441 25.9141 64.5656V64.1264C25.9141 63.6872 25.9141 63.6872 25.9141 63.2479C25.9141 62.8087 25.9141 62.8087 25.9141 62.3695H0C0 96.6289 27.671 124.3 62.3696 124.3C96.629 124.3 124.739 96.6289 124.739 61.9303H99.2643V62.3695ZM82.5739 97.9465L92.2367 90.4798L94.4329 93.1151L90.9191 95.7504L99.2643 106.292L96.629 108.488L87.8445 97.9465L84.3307 100.582L82.5739 97.9465ZM78.6208 99.7034C79.4993 99.2642 80.3777 99.2642 81.2562 99.7034C82.1346 100.143 82.5739 100.582 83.0131 101.9L84.3307 105.413C84.77 106.731 84.3307 108.488 83.4523 109.366L87.8445 114.198L84.3307 115.515L79.9385 110.684L77.7424 111.562L79.9385 117.272L76.4247 118.59L70.2756 102.339L78.6208 99.7034ZM56.2205 106.292C56.2205 105.413 56.6597 104.535 57.0989 103.656C57.5382 103.217 58.4166 102.778 59.7343 102.778H65.4442C67.6403 102.778 68.958 104.096 68.958 106.292V116.394C68.958 117.272 68.5187 118.151 68.0795 119.029C67.6403 119.468 66.7618 119.908 65.4442 119.908H59.7343C57.5382 119.908 56.2205 118.59 56.2205 116.394V106.292ZM43.483 98.825L51.389 101.9C52.2675 102.339 53.1459 102.778 53.5852 103.656C54.0244 104.535 54.0244 105.413 53.5852 106.292L52.2675 109.806C51.8283 110.684 51.389 111.562 50.5106 112.002C49.6322 112.441 48.7537 112.441 47.8753 112.002L43.0438 110.245L41.2869 115.515L37.7731 114.198L43.483 98.825ZM23.718 101.021L25.0357 99.2642L27.671 101.46L26.7926 102.778C26.3534 103.217 26.3534 103.217 26.7926 103.656L29.4279 105.853H29.8671C29.8671 105.853 30.3064 105.853 30.3064 105.413L31.1848 104.096C31.624 103.656 31.1848 103.656 31.1848 103.217L28.5495 99.7034C27.2318 97.9465 26.7926 96.1896 28.1102 94.872L29.8671 92.6759C30.7456 92.2366 31.624 91.7974 32.5025 91.7974C33.3809 91.7974 34.2594 91.7974 35.1378 92.6759L39.0908 95.7504C40.4085 96.6289 40.4085 98.825 39.53 100.143L38.2124 101.9L35.1378 99.7034L36.0163 98.3858C36.4555 97.9465 36.4555 97.9465 36.0163 97.5073L33.3809 95.3112C32.9417 94.872 32.9417 94.872 32.5025 95.3112L31.624 96.6289C31.1848 97.0681 31.624 97.0681 31.624 97.5073L34.6986 101.021C36.0163 102.778 36.4555 104.535 35.1378 105.853L33.3809 108.049C32.9417 108.927 32.0633 109.366 31.1848 109.366C30.7456 109.806 30.7456 109.806 30.7456 109.806C29.8671 109.806 29.4279 109.366 28.5495 108.927L24.5965 105.853C23.718 105.413 23.2788 104.535 23.2788 103.656C22.8396 102.339 23.2788 101.46 23.718 101.021Z" fill="black"></path> <path d="M35.5775 87.8445C34.699 86.9661 34.2598 86.0876 33.3813 85.6484C34.2598 86.5269 35.1382 87.4053 35.5775 87.8445Z" fill="#FDB515"></path> <path d="M34.6977 101.021C36.0154 102.778 36.4546 104.535 35.137 105.853L33.3801 108.049C32.9408 108.927 32.0624 109.367 31.1839 109.367C30.7447 109.806 30.7447 109.806 30.7447 109.806C29.8663 109.806 29.4271 109.367 28.5486 108.927L24.5956 105.853C23.7172 105.414 23.2779 104.535 23.2779 103.657C23.2779 102.778 23.2779 101.9 24.1564 101.021L25.4741 99.2644L28.1094 101.461L27.2309 102.778C26.7917 103.217 26.7917 103.217 27.2309 103.657L29.8663 105.853H30.3055C30.3055 105.853 30.7447 105.853 30.7447 105.414L31.6232 104.096C32.0624 103.657 31.6232 103.657 31.6232 103.217L28.9878 99.7036C27.6702 97.9468 27.2309 96.1899 28.5486 94.8722L30.3055 92.6761C30.7447 92.2369 31.6232 91.7976 32.5016 91.7976C33.3801 91.7976 34.2585 91.7976 35.137 92.6761L39.09 95.7506C40.4076 96.6291 40.4076 98.8252 39.5292 100.143L38.2115 101.9L35.137 99.7036L36.0154 98.386C36.4546 97.9468 36.4546 97.9468 36.0154 97.5075L33.3801 95.3114C32.9408 94.8722 32.9408 94.8722 32.5016 95.3114L31.6232 96.6291C31.1839 97.0683 31.6232 97.0683 31.6232 97.5075L34.6977 101.021Z" fill="black"></path> <path d="M53.5856 103.217C54.0248 104.096 54.0248 104.974 53.5856 105.853L52.2679 109.806C51.8287 110.684 51.3895 111.563 50.511 112.002C49.6326 112.441 48.7541 112.441 47.8757 112.002L43.0442 110.245L41.2874 115.516L37.7736 114.198L43.4835 98.386L51.3895 101.021C52.7071 101.9 53.1464 102.339 53.5856 103.217Z" fill="black"></path> <path d="M68.5196 106.292V116.394C68.5196 117.273 68.0804 118.151 67.6411 119.029C67.2019 119.469 66.3235 119.908 65.0058 119.908H59.2959C57.0998 119.908 55.7821 118.59 55.7821 116.394V106.292C55.7821 105.414 56.2214 104.535 56.6606 103.657C57.0998 103.217 57.9782 102.778 59.2959 102.778H65.0058C66.7627 102.778 68.5196 104.096 68.5196 106.292Z" fill="black"></path> <path d="M32.0624 83.4521L63.2472 52.7065L35.137 46.9966H85.6476L51.3882 71.1539L68.5179 76.4245L63.6864 66.7616L71.1532 61.491L75.5454 84.3305L51.3882 71.5931L32.9408 84.3305C32.0624 83.8913 32.0624 83.4521 32.0624 83.4521Z" fill="black"></path> <path d="M83.0131 108.927L87.8445 114.198L84.3307 115.516L79.9385 110.684L77.7424 111.563L79.9385 117.273L76.4247 118.59L70.2756 102.339L78.1816 99.2644C79.0601 98.8252 79.9385 98.8252 80.817 99.2644C81.6954 99.7036 82.1346 100.143 82.5738 101.461L83.8915 104.974C84.77 106.731 84.3307 108.049 83.0131 108.927Z" fill="black"></path> <path d="M98.8242 106.292L96.1889 108.488L87.8437 97.9465L84.3299 100.582L82.573 97.9465L92.2359 90.4798L93.9928 93.1151L90.9182 95.7504L98.8242 106.292Z" fill="black"></path> <path d="M90.0398 43.4833H71.5924L80.8161 34.2596C84.3299 36.8949 87.4044 39.9695 90.0398 43.4833Z" fill="black"></path> <path d="M7.46737 49.1933L7.02815 52.2678L22.4009 55.3424L22.8402 52.2678L7.46737 49.1933Z" fill="black"></path> <path d="M29.8686 36.8952L16.2527 28.9892L14.935 31.6245L24.1587 36.8952H11.8605L10.1036 39.5305L23.7195 47.4365L25.0371 44.8012L16.2527 39.5305L28.5509 39.9697L29.8686 36.8952Z" fill="black"></path> <path d="M36.4569 22.8398L34.7 20.6437L30.3078 24.1575L27.6725 21.5222L33.3824 17.1299L31.6255 14.4946L23.2802 21.0829L33.3824 33.3812L36.0177 31.1851L31.6255 26.3536L36.4569 22.8398Z" fill="black"></path> <path d="M54.4643 18.8868L51.3898 9.66312C50.9506 7.90623 49.1937 7.02778 47.4368 7.467L42.1661 9.22389C40.4092 9.66312 39.97 11.42 40.4092 13.1769L43.4838 22.4006C43.923 24.1575 45.6799 25.0359 47.4368 24.5967L52.2682 22.8398C54.0251 22.4006 54.9036 20.6437 54.4643 18.8868ZM50.5113 20.2045L46.9976 21.5221C46.5583 21.5221 46.1191 21.5221 46.1191 21.0829L43.4838 12.7377C43.4838 12.2985 43.4838 11.8592 43.923 11.8592L47.4368 10.5416C47.876 10.5416 48.3152 10.5416 48.3152 10.9808L50.9506 19.326C51.3898 19.7652 50.9506 20.2045 50.5113 20.2045Z" fill="black"></path> <path d="M71.5939 13.1769L72.0331 9.66314C72.0331 7.90625 71.1546 6.58858 68.9585 6.14936L61.0525 5.71014L59.7349 21.5222L62.8094 21.9614L63.2486 16.2515H65.884L68.0801 21.9614L71.5939 22.4006L69.3978 16.2515C70.7154 15.8123 71.5939 14.9338 71.5939 13.1769ZM68.5193 12.2985C68.5193 12.7377 68.0801 13.1769 67.6409 13.1769L63.6879 12.7377V8.78469L67.6409 9.22392C68.0801 9.22392 68.5193 9.66314 68.5193 10.1024V12.2985Z" fill="black"></path> <path d="M93.1162 14.934L85.2102 21.0831L86.0886 10.981L83.0141 9.22413L75.5473 23.2793L78.1826 24.5969L83.4533 15.3732L82.5749 24.1577L84.771 25.4754L91.7985 20.2047L86.5279 29.4284L89.1632 30.746L96.63 16.6909L93.1162 14.934Z" fill="black"></path> <path d="M108.05 34.2594L110.246 32.5025L104.097 24.1573L91.3598 33.8202L97.5089 42.1654L99.705 40.4085L95.3128 34.6986L98.3873 32.5025L101.901 37.334L104.536 35.1378L101.023 30.7456L103.658 28.9887L108.05 34.2594Z" fill="black"></path> <path d="M117.273 49.6322L115.077 41.7262L99.7046 46.1184L101.901 54.0244C102.34 55.7813 104.097 56.6598 105.854 56.2205L115.077 53.5852C116.834 52.7067 117.713 51.3891 117.273 49.6322ZM113.76 50.5106L105.414 52.7067C104.975 52.7067 104.536 52.7067 104.536 52.2675L103.218 48.3145L112.881 45.6792L114.199 49.6322C114.199 50.0714 114.199 50.5106 113.76 50.5106Z" fill="black"></path> <path d="M39.5293 100.143L38.2116 101.9L35.1371 99.7037L36.0155 98.386C36.4547 97.9468 36.4547 97.9468 36.0155 97.5076L33.3802 95.3114C32.9409 94.8722 32.9409 94.8722 32.5017 95.3114L31.6233 96.6291C31.1841 97.0683 31.6233 97.0683 31.6233 97.5076L34.6978 101.021C36.0155 102.778 36.4547 104.535 35.1371 105.853L33.3802 108.049C32.9409 108.927 32.0625 109.367 31.1841 109.367C30.7448 109.806 30.7448 109.806 30.7448 109.806C29.8664 109.806 29.4272 109.367 28.5487 108.927L24.5957 105.853C23.7173 105.414 23.278 104.535 23.278 103.657C23.278 102.778 23.278 101.9 24.1565 101.021L25.4742 99.2644L28.1095 101.461L27.2311 102.778C26.7918 103.217 26.7918 103.217 27.2311 103.657L29.8664 105.853H30.3056C30.3056 105.853 30.7448 105.853 30.7448 105.414L31.6233 104.096C32.0625 103.657 31.6233 103.657 31.6233 103.217L28.9879 99.7037C27.6703 97.9468 27.2311 96.1899 28.5487 94.8722L30.3056 92.6761C30.7448 92.2369 31.6233 91.7977 32.5017 91.7977C33.3802 91.7977 34.2586 91.7977 35.1371 92.6761L39.0901 95.7507C40.4077 96.6291 40.4077 98.8252 39.5293 100.143Z" fill="white"></path> <path d="M53.5835 103.217C53.1443 102.339 52.7051 101.9 51.3874 101.46L43.4814 98.8251L37.7715 114.637L41.2853 115.955L43.0422 110.684L47.8737 112.441C48.7521 112.88 49.6305 112.88 50.509 112.441C51.3874 112.002 51.8267 111.563 52.2659 110.245L53.5835 106.292C54.0228 104.974 54.0228 104.096 53.5835 103.217ZM50.0698 105.413L49.1913 108.049C49.1913 108.049 49.1913 108.488 48.7521 108.488H48.3129L44.3599 107.17L45.6775 103.217L49.6305 104.535C49.6305 104.535 50.0698 104.535 50.0698 104.974C50.0698 104.974 50.0698 104.974 50.0698 105.413Z" fill="white"></path> <path d="M65.0038 102.778H59.2939C58.4154 102.778 57.537 103.217 56.6585 103.657C56.2193 104.096 55.7801 104.974 55.7801 106.292V116.394C55.7801 118.59 57.0978 119.908 59.2939 119.908H65.0038C65.8822 119.908 66.7607 119.469 67.6391 119.029C68.0783 118.59 68.5176 117.712 68.5176 116.394V106.292C68.5176 104.096 66.7607 102.778 65.0038 102.778ZM64.5645 115.516V115.955H64.1253H60.1723C59.7331 115.955 59.7331 115.955 59.7331 115.516V106.731C59.7331 106.292 59.7331 106.292 60.1723 106.292H64.1253H64.5645V106.731V115.516Z" fill="white"></path> <path d="M83.0132 108.927C84.3308 108.049 84.3309 106.731 83.8916 104.974L82.574 101.461C82.1347 100.582 81.6955 99.7037 80.8171 99.2644C79.9386 98.8252 79.0602 98.8252 78.1817 99.2644L70.2757 102.339L75.9856 118.151L79.4994 116.833L77.3033 111.123L79.4994 110.245L83.8916 115.076L87.8446 114.198L83.0132 108.927ZM80.3778 106.731L76.4248 108.049L75.1072 104.535L79.0602 103.217H79.4994C79.4994 103.217 79.9386 103.217 79.9386 103.657L80.8171 106.292L80.3778 106.731Z" fill="white"></path> <path d="M98.8243 106.292L96.189 108.488L87.8438 97.9465L84.33 100.582L82.5731 97.9465L92.236 90.4798L93.9929 93.1151L90.9183 95.7504L98.8243 106.292Z" fill="white"></path> `                    ;
            isIcon += `</g>`;
            isIcon += `<defs>`;
            isIcon += `<clippath id="clip-informed-sport"><rect fill="white" height="124.3" width="124.3"></rect></clippath> `;
            isIcon += `</defs> `;
            isIcon += `</svg>`;
            isIcon += `</div>`;

        let informedSportProducts = scope !== null ? $(`${scope} [data-informed-sport]`) : $('[data-informed-sport]');
        //console.log("Adding icons for: ", informedSportProducts);
        informedSportProducts.each(function (i, product) {
            $(product).append(isIcon);

            $(product).find('#informed_sport_icon')
              .removeClass('second third')
              .addClass('first');
        });
    }

    loadInformedSportIcons();
    window.loadInformedSportIcons = loadInformedSportIcons;

    // Add IFOS Icon
    function loadIFOSIcons(scope = null) {
        let ifosIcon = `
            <div id="ifos_icon">
              <svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="124.3" height="124.3" viewBox="0 0 467.5 376.8" style="enable-background:new 0 0 467.5 376.8;" xml:space="preserve">
                <style type="text/css">
                  .st0{fill:#FFFFFF;}
                  .st1{fill:#015BAA;}
                  .st2{fill:#FCFCFD;}
                </style>
                <g>
                  <path class="st0" d="M306.1,189.7c-3.3-0.8-8.7-2.3-11,3.3c-3.8,9.4-7.6,18.9-9.4,28.9c-1.8,9.8-1.4,19.2,6.5,26.9   c2.1,2,3.7,2.5,6.5,1.5c26.4-9.2,40.3-28,43.1-55.5c2.7-26.4-9.9-51.9-32.6-64.3c-11.4-6.2-23.6-8.3-36.9-7.6   c2.8,5.2,5.7,9.6,9.1,13.6c7.6,9,12.6,19.3,13.8,31c0.3,3.2,0.8,8.3,0.9,11.2c1.1,0.7,3.9,2.7,6,5   C304.5,186.1,306,188.7,306.1,189.7z M265,123.3c-14,1.8-26.1,7.2-36.1,16.9c-21.9,21.3-26.2,59.4-9.5,85c8,12.2,19.1,20.7,33.2,25   c1.6,0.5,3.1,1.5,4.4-0.5c4.3-6.5,9.4-12.6,11.1-20.4c2.3-9.9-0.8-18.7-6.6-26.7c-15.1-21.2-15.7-43.4-4.3-66.3   C259.6,131.9,262.4,127.8,265,123.3z M262.4,252c7.5,1.5,15.1,2.1,23.6,0.5C277.6,249.6,270.1,248.2,262.4,252z M275.7,139.3   c-0.3-2-0.8-3.9-3.2-3.6c-2.2,0.3-3,2-2.9,4c0,1.9,0.6,3.8,3,3.7C275.1,143.4,275.5,141.3,275.7,139.3z M261.1,160   c1,4.1,1.5,9.3,4.3,11.6c2.8,2.3,7.8,1.6,10.3,0c-2.4-0.2-6.6,0-9.2-2.2C263.6,166.9,262.4,162,261.1,160z"/>
                  <path class="st1" d="M61.3,126c13.8-19.3,30.9-35.3,50.1-49C164.5,39.4,223.6,20.6,289,23.3c33.2,1.4,64.8,9.5,92.9,28.1   c47.2,31.1,64.8,83.8,45.8,137.1c-1.7,4.8-3.8,9.6-5.8,14.3c-3.4-6.1-8.3-10.8-14-14.7c-5.2-3.5-10.6-6.9-15.9-10.2   c-6.2-3.8-12.6-7.5-18.2-12.2c-3.5-2.9-6.3-6.3-7.6-10.8c-2.8-9.5,2.1-20.2,11-24.2c10.9-4.9,24.3-1.4,30.2,8   c2.7,4.3,4.3,9,5.4,13.9c0.5,2.2,1.6,3.2,3.8,2.8c2.6-0.4,1.7-2.4,1.6-3.9c-0.6-6.8-1.6-13.6-2-20.4c-0.2-3.8-1.3-5.6-5.5-5.5   c-3.1,0.1-6.2-1-9.3-1.5c-13.2-2.4-26-2.5-37.8,5.7c-16.1,11.2-21.4,36.9-1.6,51.9c5.9,4.4,12,8.4,18.3,12.1   c7,4.1,14.1,8.2,20.2,13.8c6,5.5,9.2,12.2,7.4,20.5c-0.2,0.3-0.3,0.6-0.5,1l0.1-0.1c-4,5.4-8.1,10.7-12.1,16.1l0.1-0.1   c-0.3,0.3-0.6,0.6-1,0.9c-14,5-29.2-0.7-36.3-13.7c-2.4-4.4-4.2-9-5.6-13.8c-0.6-2-1.7-2.7-3.6-2.5c-2.2,0.2-2,1.7-1.8,3.3   c0.6,8.6,1.2,17.3,1.8,25.9c0.1,1.5-0.1,2.8,2.2,3c12.1,1,23.6,5.7,35.9,5.8c-30.4,32.4-67.4,54.5-109,69.1   c-23.5,8.3-47.7,13.4-72.6,15.1c-0.8,0.1-1.7-0.1-2,1c-11,0-22,0-33,0c-6.1-2.4-12.6-1.9-18.9-2.9c-28-4.6-54.2-13.5-77.1-30.7   C32.1,273.6,17.5,223,35.7,172.5c4.5-12.6,10.3-24.5,17.8-35.6c1.5,1.6,1.8,3.6,1.8,5.5c0,30.1,0.1,60.3,0,90.4   c0,5.4-2.7,9.2-8.1,10.6c-2.4,0.6-4.9,1.1-7.3,1.6c-2,0.4-4.8-0.2-4.5,3.2c0.3,3.6,3.2,2.3,5,2.2c15.6-0.8,31.2-1.2,46.8,0   c2.2,0.2,6.2,1.9,6.7-1.9c0.6-4.5-3.8-3.1-6.2-3.6c-11.3-2.2-13.5-4.8-13.5-16.3c0-9.7,0-19.3,0-29c0-18,0-36,0-53.9   c0-9.5,2-11.8,11.3-14c1.8-0.4,3.6-0.6,5.4-0.9c1.8-0.3,3.3-0.7,3.2-3c-0.1-2.3-1.6-2.6-3.5-2.5c-1.3,0.1-2.7,0.1-4,0.2   C78.2,125.8,69.7,126.7,61.3,126z M306.1,189.7c-3.3-0.8-8.7-2.3-11,3.3c-3.8,9.4-7.6,18.9-9.4,28.9c-1.8,9.8-1.4,19.2,6.5,26.9   c2.1,2,3.7,2.5,6.5,1.5c26.4-9.2,40.3-28,43.1-55.5c2.7-26.4-9.9-51.9-32.6-64.3c-11.4-6.2-23.6-8.3-36.9-7.6   c2.8,5.2,5.7,9.6,9.1,13.6c7.6,9,12.6,19.3,13.8,31c0.3,3.2,0.8,8.3,0.9,11.2c1.1,0.7,3.9,2.7,6,5   C304.5,186.1,306,188.7,306.1,189.7z M265,123.3c-14,1.8-26.1,7.2-36.1,16.9c-21.9,21.3-26.2,59.4-9.5,85c8,12.2,19.1,20.7,33.2,25   c1.6,0.5,3.1,1.5,4.4-0.5c4.3-6.5,9.4-12.6,11.1-20.4c2.3-9.9-0.8-18.7-6.6-26.7c-15.1-21.2-15.7-43.4-4.3-66.3   C259.6,131.9,262.4,127.8,265,123.3z M156.1,125.5c-14.5,0.6-29,1-43.4-0.2c-1.7-0.1-3,0.2-3.3,2.1c-0.3,2.1,0.9,3,2.8,3.3   c2.9,0.5,5.9,0.9,8.8,1.7c6,1.8,8.2,4.6,8.2,10.9c0.1,29.8,0.1,59.6,0,89.4c0,6.1-2,8.6-7.9,10.6c-2.4,0.8-4.8,1.2-7.3,1.7   c-2,0.4-4.8-0.1-4.6,3.2c0.2,3.5,3.2,2.3,5,2.3c13.8-0.6,27.6-1.4,41.4-0.3c3.1,0.3,6.3,0.3,9.5,0.3c1.5,0,2.7-0.3,2.9-2   c0.2-1.8-0.7-2.8-2.4-3.2c-2.4-0.5-4.9-0.8-7.4-1.3c-7.6-1.7-10.2-4.7-10.3-12.4c-0.1-13,0.1-26-0.1-39c-0.1-3.3,1.2-3.8,4.1-3.7   c5.2,0.2,10.3,0,15.5,0.1c10,0,13.4,2.6,16,12.1c0.4,1.6,0.6,3.3,1.1,4.9c0.5,2,0.2,4.7,3.6,4.1c3.2-0.5,2.1-3.1,1.9-4.8   c-1.1-12.5-1.3-24.9,0-37.4c0.2-1.8,1.5-4.6-2.1-5.1c-3.5-0.4-2.8,2.5-3.4,4.3c-0.4,1.1-0.3,2.3-0.6,3.4   c-2.3,9.3-5.8,12.2-15.4,12.4c-5.8,0.1-11.7-0.1-17.5,0.1c-2.4,0.1-3.1-0.8-3.1-3.1c0.1-12.7-0.1-25.3,0.1-38   c0.1-6.1,3.3-9.1,9.4-9.4c4.8-0.2,9.7,0.1,14.5-0.1c15-0.5,26.3,4.9,31.5,19.9c0.7,2.1,2.1,3,4.2,2.1c2.3-0.9,1.2-2.6,0.8-4.2   c-1.8-7.3-3.7-14.5-5.2-21.8c-0.6-2.7-1.6-3.2-4.3-3.2C184.7,125.6,170.4,125.5,156.1,125.5z M262.4,252c7.5,1.5,15.1,2.1,23.6,0.5   C277.6,249.6,270.1,248.2,262.4,252z M275.7,139.3c-0.3-2-0.8-3.9-3.2-3.6c-2.2,0.3-3,2-2.9,4c0,1.9,0.6,3.8,3,3.7   C275.1,143.4,275.5,141.3,275.7,139.3z M261.1,160c1,4.1,1.5,9.3,4.3,11.6c2.8,2.3,7.8,1.6,10.3,0c-2.4-0.2-6.6,0-9.2-2.2   C263.6,166.9,262.4,162,261.1,160z"/>
                  <path class="st2" d="M407.8,228.2c1.7-8.4-1.4-15-7.4-20.5c-6.1-5.5-13.1-9.6-20.2-13.8c-6.3-3.7-12.4-7.7-18.3-12.1   c-19.8-15-14.5-40.7,1.6-51.9c11.8-8.2,24.5-8.1,37.8-5.7c3.1,0.6,6.2,1.6,9.3,1.5c4.2-0.1,5.3,1.7,5.5,5.5   c0.4,6.8,1.4,13.6,2,20.4c0.1,1.5,1,3.5-1.6,3.9c-2.2,0.4-3.3-0.6-3.8-2.8c-1.2-4.9-2.7-9.6-5.4-13.9c-5.9-9.4-19.3-12.9-30.2-8   c-9,4-13.8,14.7-11,24.2c1.3,4.5,4.2,7.9,7.6,10.8c5.6,4.7,12,8.4,18.2,12.2c5.4,3.3,10.7,6.7,15.9,10.2c5.7,3.9,10.6,8.6,14,14.7   c8.1,25.9-5.8,47.5-32.7,50.4c-0.8,0.1-1.6,0.4-2.4,0.6c-12.3-0.1-23.8-4.8-35.9-5.8c-2.3-0.2-2.1-1.5-2.2-3   c-0.6-8.6-1.2-17.3-1.8-25.9c-0.1-1.6-0.4-3.1,1.8-3.3c1.9-0.2,3.1,0.5,3.6,2.5c1.4,4.8,3.2,9.4,5.6,13.8   c7.1,13,22.3,18.7,36.3,13.7c0.5-0.1,1.1-0.1,1-0.9l-0.1,0.1c7-1.7,11.6-7.8,12.1-16.1c0,0-0.1,0.1-0.1,0.1   C407.5,228.8,407.6,228.5,407.8,228.2z"/>
                  <path class="st2" d="M61.3,126c8.5,0.8,16.9-0.2,25.4-0.6c1.3-0.1,2.7-0.1,4-0.2c1.8-0.1,3.4,0.3,3.5,2.5c0.1,2.3-1.5,2.7-3.2,3   c-1.8,0.3-3.6,0.5-5.4,0.9c-9.4,2.2-11.3,4.5-11.3,14c-0.1,18,0,36,0,53.9c0,9.7,0,19.3,0,29c0,11.6,2.3,14.2,13.5,16.3   c2.4,0.5,6.8-0.8,6.2,3.6c-0.5,3.8-4.5,2.1-6.7,1.9c-15.6-1.2-31.2-0.7-46.8,0c-1.8,0.1-4.7,1.3-5-2.2c-0.3-3.4,2.6-2.8,4.5-3.2   c2.4-0.5,4.9-1,7.3-1.6c5.4-1.4,8.1-5.2,8.1-10.6c0.1-30.1,0-60.3,0-90.4c0-2-0.3-4-1.8-5.5c-2.5-4.3-7.1-4.6-11.2-5.7   c-1.4-0.4-3-0.4-4.4-0.7c-1.7-0.2-2.7-1.1-2.6-3c0.1-2,1.4-2.5,3.1-2.4c5.8,0.3,11.6,0.6,17.4,0.8C57.6,126.1,59.4,126,61.3,126z"/>
                  <path class="st2" d="M156.1,125.5c14.3,0,28.6,0.1,42.9-0.1c2.7,0,3.8,0.5,4.3,3.2c1.6,7.3,3.4,14.6,5.2,21.8   c0.4,1.6,1.5,3.3-0.8,4.2c-2.1,0.9-3.5-0.1-4.2-2.1c-5.2-15-16.5-20.4-31.5-19.9c-4.8,0.2-9.7-0.1-14.5,0.1   c-6.1,0.2-9.3,3.3-9.4,9.4c-0.2,12.7,0,25.3-0.1,38c0,2.4,0.7,3.2,3.1,3.1c5.8-0.2,11.7,0.1,17.5-0.1c9.6-0.2,13.1-3.1,15.4-12.4   c0.3-1.1,0.3-2.3,0.6-3.4c0.6-1.8-0.1-4.7,3.4-4.3c3.6,0.5,2.3,3.3,2.1,5.1c-1.2,12.5-1.1,24.9,0,37.4c0.1,1.7,1.2,4.2-1.9,4.8   c-3.4,0.6-3.1-2.1-3.6-4.1c-0.4-1.6-0.6-3.3-1.1-4.9c-2.6-9.6-6-12.1-16-12.1c-5.2,0-10.3,0.1-15.5-0.1c-2.8-0.1-4.1,0.4-4.1,3.7   c0.2,13,0,26,0.1,39c0.1,7.7,2.7,10.7,10.3,12.4c2.4,0.5,4.9,0.8,7.4,1.3c1.7,0.3,2.6,1.4,2.4,3.2c-0.2,1.7-1.5,2.1-2.9,2   c-3.2-0.1-6.3-0.1-9.5-0.3c-13.8-1.1-27.6-0.3-41.4,0.3c-1.9,0.1-4.8,1.2-5-2.3c-0.2-3.3,2.6-2.8,4.6-3.2c2.4-0.5,4.9-0.9,7.3-1.7   c5.9-1.9,7.9-4.5,7.9-10.6c0.1-29.8,0.1-59.6,0-89.4c0-6.2-2.3-9.1-8.2-10.9c-2.9-0.8-5.8-1.2-8.8-1.7c-1.9-0.3-3.1-1.2-2.8-3.3   c0.3-2,1.6-2.3,3.3-2.1C127.2,126.5,141.7,126,156.1,125.5z"/>
                  <g>
                    <path class="st1" d="M404.8,52.7V40.1h-4.4v-1.7H411v1.7h-4.5v12.6H404.8z"/>
                    <path class="st1" d="M412.8,52.7V38.4h2.7l3.2,10.1c0.3,0.9,0.5,1.6,0.6,2.1c0.2-0.5,0.4-1.3,0.7-2.3l3.2-9.9h2.4v14.3H424v-12    l-3.9,12h-1.6l-3.9-12.2v12.2H412.8z"/>
                  </g>
                </g>
              </svg>
            </div>
        `;

        let ifosProducts = scope !== null ? $(`${scope} [data-ifos]`) : $('[data-ifos]');
        //console.log("Adding icons for: ", ifosProducts);
        ifosProducts.each(function (i, product) {
            $(product).append(ifosIcon);
            const hasInformed = $(product).find('#informed_sport_icon').length > 0;
            $(product).find('#ifos_icon')
              .removeClass('first second third')
              .addClass(hasInformed ? 'second' : 'first');
        });
    }

    loadIFOSIcons();
    window.loadIFOSIcons = loadIFOSIcons;

    function loadNationalCeliacIcons(scope = null) {
        let isImg  = `<div id="national_celiac_image">`;
            isImg += `<img class="image" src="https://cdn.shopify.com/s/files/1/0274/9507/1796/files/GF_-_Icon_bbe21cc2-eee4-4b01-b101-8b717cabaf94.png?v=1637097065" sizes="100vw" alt="nationalceliac-image" width="100" height="100" loading="lazy">`;
            isImg += `</div>`;
        
        let nationalCeliacProducts = scope !== null ? $(`${scope} [data-national-celiac]`) : $('[data-national-celiac]');
        //console.log("Adding icons for: ", nationalCeliacProducts);
        nationalCeliacProducts.each(function (i, product) {
            $(product).append(isImg);
            const hasInformed = $(product).find('#informed_sport_icon').length > 0;
            const hasIfos     = $(product).find('#ifos_icon').length > 0;
            const slot = (hasInformed && hasIfos) ? 'third'
              : (hasInformed || hasIfos) ? 'second'
                : 'first';

            $(product).find('#national_celiac_image')
              .removeClass('move-top first second third')
              .addClass(slot);
        });
    }

    loadNationalCeliacIcons();
    window.loadNationalCeliacIcons = loadNationalCeliacIcons;

    /***** Filters collection *****/    
    if ($(".filter").length > 0) {

        $(".icon-dropdown").on('click', function (event) {
            $(this).parent().parent().toggleClass('open');
        })

        var listTagsChangeHandler = {
            get: function(target, property) {
              //console.log('getting ' + property + ' for ' + target);
              // property is index in this case
              return target[property];
            },
            set: function(target, property, value, receiver) {
              //console.log('setting ' + property + ' for ' + target + ' with value ' + value);
              target[property] = value;

            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                searchParams.set('filters', listTags);
                //window.location.search = searchParams.toString();
            }

              // you have to return true to accept the changes
              return true;
            }
        };
        window.listTags = [];
        var proxyToListTags = new Proxy( listTags, listTagsChangeHandler);

        const querystring = window.location.search
        const paramsQuery = new URLSearchParams(querystring)
        const filters = paramsQuery.get('filters');

        if (filters) {
            listTags = filters.split("__");
        }
        
        loadTags();

        // Global collection filter configuration
        $(".all .checkbox-filter-collection").on("click", function (event) {
            event.stopImmediatePropagation();
            const $checkbox = $(this).find('.checkbox')
            if (!$checkbox.hasClass('category-all')) {
                const params = listTags.join("__");
                window.location = $checkbox.data('handle') + '?filters=' + params;
                return;
            }
            $collection = $(`.collection-handle[data-handle=${$checkbox.data('handle').replace("/collections/", "")}]`);
            handleCheckedGroup($checkbox, function () {
                $collection.removeClass('remove-collection');
                $collection.show();
            }, function () {
                $collection.addClass('remove-collection');
                $collection.hide();
            })
            handleSearchTagCollection();
        })

        $(".all .checkbox-filter-group").on("click", function (event) {
            event.stopImmediatePropagation();
            const $checkbox = $(this).find('.checkbox')
            if (!$checkbox.hasClass('category-all')) {
                window.location = '/collections/all';
                return;
            }
            const $filtersCheckbox = $checkbox.parents('.dropdown').find('.checkbox-filter-collection .checkbox');
            $checkbox.toggleClass('checked')
            if ($checkbox.hasClass('checked')) {
                $filtersCheckbox.each(function (index, $check) {
                    const $collection = $(`.collection-handle[data-handle=${$($check).data('handle').replace("/collections/", "")}]`);
                    $collection.removeClass('remove-collection');
                    $collection.show();
                    $($check).addClass('checked')
                })
            }
            else {
                $filtersCheckbox.each(function (index, $check) {
                    const $collection = $(`.collection-handle[data-handle=${$($check).data('handle').replace("/collections/", "")}]`);
                    $collection.addClass('remove-collection');
                    $collection.hide();
                    $($check).removeClass('checked');
                })
            }
            handleSearchTagCollection();
        });

        // Secondary collection filter configuration
        $(".dropdown:not(.all) .checkbox-filter-collection").on("click", function (event) {           
            const $checkbox = $(this).find('.checkbox')
            handleCheckedGroup($checkbox, function () {
                //console.log('Clicked tag', $checkbox);
                const tag = $checkbox.data('title');
                proxyToListTags.push(tag)
                //console.log(`Updated list of tags: ${listTags}`);
            }, function () {
                const tag = $checkbox.data('title');
                removeTag(tag);
            })
            handleSearchTagCollection();
        })

        $(".dropdown:not(.all) .checkbox-filter-group").on("click", function (event) {
            event.stopImmediatePropagation();
            const $checkbox = $(this).find('.checkbox')
            $checkbox.toggleClass('checked');
            if ($checkbox.hasClass('checked')) {
                $checkbox.parents('.dropdown').find('.checkbox-filter-collection .checkbox:not(.checked)').each(function (index, $check) {
                    //console.log(`Checked filter ${$($check)}`);
                    const tag = $($check).data('title');
                    proxyToListTags.push(tag);
                    //console.log(`Updated list of tags: ${listTags}`);
                    $($check).addClass('checked');
                })
            }
            else {
                $checkbox.parents('.dropdown').find('.checkbox-filter-collection .checkbox.checked').each(function (index, $check) {
                    const tag = $($check).data('title');
                    removeTag(tag);
                    $($check).removeClass('checked');
                })
            }
            handleSearchTagCollection();
        })

        $(".filter-bar").on("click", ".filter-tab .close", function (event) {
            event.stopImmediatePropagation();
            const tag = $(this).parent().data('tag');
            //console.log('Clicked tag', tag);
            const $checkbox = $(`.dropdown:not(.all) .checkbox-filter-collection .checkbox[data-title='${tag}']`);
            $checkbox.removeClass('checked');
            $checkbox.parents('.dropdown').find(".checkbox-filter-group .checkbox").removeClass('checked');
            removeTag(tag);
            handleSearchTagCollection();
        })

        $(".filter-bar").on("click", ".filter-tab .close-all", function (event) {
            $(`.dropdown:not(.all) .checkbox-filter-collection .checkbox`).removeClass('checked');
            $(".dropdown:not(.all) .checkbox-filter-group .checkbox").removeClass('checked');
            proxyToListTags.length = 0;
            handleSearchTagCollection();
        })

        function handleCheckedGroup($checkbox, checked, removeCheked) {
            $checkbox.toggleClass('checked')
            const filterGroupCheckbox = $checkbox.parents('.dropdown').find(".checkbox-filter-group .checkbox");
            if ($checkbox.hasClass('checked')) {
                checked();
                if ($checkbox.parents('.dropdown').find('.checkbox-filter-collection .checkbox:not(.checked)').length == 0) {
                    filterGroupCheckbox.addClass('checked');
                }
            }
            else {
                removeCheked();
                filterGroupCheckbox.removeClass('checked');
            }
        }

        function removeTag(item) {
            const i = listTags.indexOf(item);
            if (i !== -1) {
                listTags.splice(i, 1);
            }
            //console.log(`Updated list of tags: ${listTags}`);
        }

        function loadTags() {
            $(".dropdown:not(.all) .checkbox-filter-collection .checkbox").each(function (index, $check) {
                const tag = $($check).data('title');
                if (listTags.includes(tag)) {
                    $($check).addClass('checked');
                    $($check).parents('.dropdown').addClass('open');
                }
            })
            handleSearchTagCollection();
        }

        function handleSearchTagCollection() {           
            const collectionHandle = $(".collection-handle");
            //console.log(`Current collection`, collectionHandle);
            console.log("I'm a function.");
            collectionHandle.each(function (index, collection){
                const collectionItem = $(collection).find(".collection-product-item");
                let foundTag = 0;
                //console.log(`Current tag list`, listTags);                
                if (listTags.length > 0) {
                    collectionItem.each(function (index, product) {
                        const tags = $(product).data('tags');
                        let hidden = 1;
                        listTags.map(function (searchTag) {
                            if (tags.split(',').map(function (tag) { return tag.toLowerCase() }).includes(searchTag.toLowerCase())) {
                                $(product).parent().show();
                                hidden = 0;
                                foundTag = 1;
                            }
                        })
                        if (hidden) {
                            $(product).parent().hide();
                        }
                    });
                    if(foundTag) {
                        if(!$(collection).hasClass('remove-collection')) {
                            $(collection).show();
                        }
                    }
                    else {
                        $(collection).hide();
                    }
                }
                else {
                    collectionItem.parent().show();
                    if(!$(collection).hasClass('remove-collection')) {
                         $(collection).show();
                    }
                }                
            }) 
            
            createTabsFilter();
        }

        function createTabsFilter() {
            $('.filter-bar').html('')
            if (listTags.length > 0) {
                $("<div />", {
                    class: "filter-tab clear",
                    html: "<span class='close-all'>X</span> CLEAR"
                }).appendTo('.filter-bar');
                listTags.map(function (tag) {
                    $("<div />", {
                        "data-tag": tag,
                        class: "filter-tab",
                        html: `<span class='close'>X</span> ${tag}`
                    }).appendTo('.filter-bar');
                })
            }
        }
    }

    /*
    *    Announcement bar mini-cart and Account
    */    
    function swapDOMElements(node1, node2) {
        const afterNode2 = node2.nextElementSibling;
        const parent = node2.parentNode;
        node1.replaceWith(node2);
        parent.insertBefore(node1, afterNode2);
    }

    function annBarActionItems(e) {
        const annBarAccountContainer = document.querySelector('.announcement-bar__action-item--account');
        const annBarMiniCartContainer = document.querySelector('.announcement-bar__action-item--cart');        
        const headerAccount = document.querySelector('.header__action-item--account');
        const headerMiniCart = document.querySelector('.header__action-item--cart');
        // Acount
        if ( e.matches && annBarAccountContainer.parentNode.classList.contains('announcement-bar__action-items') ) {
            swapDOMElements(annBarAccountContainer, headerAccount);
        } else if ( annBarAccountContainer.parentNode.classList.contains('login-card-mobile') ) {
            swapDOMElements(annBarAccountContainer, headerAccount);
        }
        // MiniCart
        if ( e.matches && annBarMiniCartContainer.parentNode.classList.contains('announcement-bar__action-items') ) {
            swapDOMElements(annBarMiniCartContainer, headerMiniCart);
        } else if ( annBarMiniCartContainer.parentNode.classList.contains('login-card-mobile') ) {
            swapDOMElements(annBarMiniCartContainer, headerMiniCart);
        }
    }

    const annBar = document.getElementById('shopify-section-announcement-bar');
    if (annBar) {
        annBarActionItems(mediaqueryMobile);
        mediaqueryMobile.addListener(annBarActionItems);
    }

    const miniCartForm = document.querySelector('.mini-cart');
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    var formObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type == "attributes") {                
                var status = mutation.target.getAttribute('aria-hidden');
                var mTimer = setInterval(function() {
                    var element = document.querySelector('#tidio-chat-iframe');
                    if(element) {
                        function moveEl(e, el) {
                            if ( status == "false" && e.matches) {
                                el.style.transform = "translate(-425px, 0px)";
                                el.style.transition = "all .4s ease";                            
                            } else if ( e.matches ) {
                                el.style.transform = "translateY(0px)";
                                el.style.transition = "all .4s ease";
                            } else {
                                el.style.transform = "translateY(1.3em)";
                                el.style.zIndex = "0";
                            }
                        }
                        moveEl(mediaqueryMobile, element);
                        mediaqueryMobile.addListener(function() { moveEl(mediaqueryMobile, element) });

                        clearInterval(mTimer);
                    }
                }, 200);
            }
        });
    });

    formObserver.observe(miniCartForm, {
        attributes: true,
        attributeFilter: ['aria-hidden']
    });
    
    document.querySelector('#mini-cart').addEventListener('click', function(e){
        if(e.target && e.target.id == 'drawer-cart__icon-arrow'){
          e.preventDefault();
          document.querySelector('.header__cart-toggle').click();
        }
    });

    /**
    *   Scrollable header
    */
    function scrollHeader(e) {
       var isHeaderSticky = $('[data-section-id="header"]').data('section-settings').useStickyHeader;
       var stickyHeaderOptions = { // => sticky header options// => sticky header options
           position: 'fixed',
           top: '0',
           left: '0',
           right: '0',
           width: '100%',
       };
        if( isHeaderSticky && e.matches ) {
            $(window).scroll(function() {
                var scrollTop = $(document).scrollTop(),
                    announcementBarHeight = $('#shopify-section-announcement-bar').height();
                scrollTop > 0 
                    ? $('#header').addClass('small--header')
                    : $('#header').removeClass('small--header');
                scrollTop > announcementBarHeight 
                    ? $('#header').css(stickyHeaderOptions) 
                    : $('#header').css('position', 'relative');
            });
        } else if( isHeaderSticky ){
            $(window).scroll(function() {
                var mobileScrollTop = $(document).scrollTop();
                if ($('#header').hasClass('small--header')) {
                    $('#header').removeClass('small--header');
                }
                if($(document).scrollTop() > 0) {
                    $('#header').css(stickyHeaderOptions);
                } else {
                    $('#header').css('position', 'relative');
                }
            });
        }
    }
    scrollHeader(mediaqueryMobile)
    mediaqueryMobile.addListener(scrollHeader);

    // Toggle 'active-filter' class into blog-template
    if (document.location.pathname === '/blogs/news') {
      var filterTags = document.querySelectorAll('.blog-cat .advanced-filters > li');
      filterTags.forEach((tag) => {
        if( tag.classList.contains('all_tag')) {
          tag.classList.add('active-filter');
        }
      });
    }
  
    // Why ATP
    $('.why-slider').slick({
        arrows: false,
        fade: false,
        speed: 250,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        draggable: true,
        swipe: true,
        dots: true,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
          {
              breakpoint: 992,
              settings: {
                draggable: false,
                swipe: false,
                dots: false
              }
          }
      ]
      });
      $('body').on('click','.why-slider-buttons .goal-item',function(e){
        $('.why-slider-buttons .goal-item').removeClass('slick-current');
        $(this).addClass('slick-current');
        var thisIndex = 0;
        thisIndex = $(this).attr('data-id') - 1;
        $('.why-slider').slick('slickGoTo',thisIndex);
      })
      $('.why-slider').on('swipe', function(event, slick, direction){
        $('.why-slider-buttons .goal-item').removeClass('slick-current');
        var goalItems = $('.why-slider-buttons .goal-item');
        var thisIndex = 0;
        thisIndex = $('.why-slider').slick('slickCurrentSlide');
        if (goalItems.length > thisIndex) $(goalItems[thisIndex]).addClass('slick-current');
    });

    /**
     * 
     *  PRODUCT-LANDING PAGE-TEMPLATE
     * 
     */
    // Product-reviews slider
    $('.product-landing--section .product-reviews [data-slider]').each(function() {
        var $slider = $(this),
            $slider$autoplay = $slider.data('autoplay-speed') > 0 ? true : false,
            $slider$autoplaySpeed = $slider.data('autoplay-speed'),
            $slider$arrows = $slider.parent().find('[data-slider-buttons]');

        $slider && $slider.slick({
          arrows: true,
          prevArrow: `<button type="button" class="slick-prev">
            <svg width="59" height="16" viewBox="0 0 59 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.292892 8.70711C-0.0976295 8.31658 -0.0976295 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM59 9H1V7H59V9Z" fill="black"/></svg>
          </button>`,
          nextArrow: `<button type="button" class="slick-next">
            <svg width="59" height="16" viewBox="0 0 59 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M58.7071 8.70711C59.0976 8.31658 59.0976 7.68342 58.7071 7.29289L52.3431 0.928932C51.9526 0.538408 51.3195 0.538408 50.9289 0.928932C50.5384 1.31946 50.5384 1.95262 50.9289 2.34315L56.5858 8L50.9289 13.6569C50.5384 14.0474 50.5384 14.6805 50.9289 15.0711C51.3195 15.4616 51.9526 15.4616 52.3431 15.0711L58.7071 8.70711ZM0 9H58V7H0V9Z" fill="black"/></svg>
          </button>`,
          autoplay: $slider$autoplay,
          autoplaySpeed: $slider$autoplaySpeed,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          draggable: true,
          dots: false,
          centerMode: false,
          appendArrows: $slider$arrows,
          mobileFirst: true,
          responsive: [
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  arrows: false,
                  centerMode: true,
                  centerPadding: '10%',
                }
            }
          ]
        });
    });

    function collectionFormsSubmit(evt, formElement) {
        evt.preventDefault();
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        jQuery.ajax({
            type: 'POST',
            url: "".concat(window.routes.cartAddUrl+'.js'),
            dataType: "json",
            data: formElement.serialize(),
            success: () => {
                jQuery.ajax({
                    type: 'GET',
                    url: "".concat(window.routes.cartUrl+'.js'),
                    dataType: "json",
                    success: (cart) => {
                        window.theme.cartCount = cart.item_count;
                        window.theme.cartOriginalTotalPrice = cart.original_total_price;

                        document.querySelector('[data-action="toggle-mini-cart"]').click();
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                        document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    }
                });
            }
        });
    }

    // Related products slider
    $('.product-landing--section .related-products [data-slider]').each(function() {
        var $slider = $(this),
            $slider$enabled = $slider.data('slider'),
            $slider$autoplay = $slider.data('autoplay-speed') > 0 ? true : false,
            $slider$autoplaySpeed = $slider.data('autoplay-speed');

        $slider && $slider$enabled && $slider.slick({
          autoplay: $slider$autoplay,
          autoplaySpeed: $slider$autoplaySpeed,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          draggable: true,
          arrows: false,
          dots: false,
          centerMode: false,
          mobileFirst: true,
          responsive: [
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  arrows: false,
                  centerMode: true,
                  centerPadding: '0',
                }
            }
          ]
        });
    });

    jQuery.getJSON("".concat(window.routes.cartUrl+'.js'), function(cart) {
        window.theme.cartOriginalTotalPrice = cart.original_total_price;
    });
});
